module.exports = __webpack_public_path__ + "media/Ok_are_you_ready.eb1a5c78.mp3";